export const getNameAlreadyUsed = (id: any, name: string, existingNameList: { id: string, name: string }[] = []) => {
    const index = existingNameList.findIndex((object: { id: any; name: string; }) => object.id !== id && object.name.toLowerCase() === name.toLowerCase());
    return index === -1 ? true : 'Name already used'
}